import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { useCountryLink } from '../context/CountryContext';

const SERIF = { fontFamily: "'Nacelle', sans-serif", fontWeight: 600 };
const SANS = { fontFamily: "'Nacelle', sans-serif", fontWeight: 400 };

const Footer = () => {
  const { link } = useCountryLink();
  return (
    <footer className="bg-black border-t border-white/5 py-16">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h3
              className="text-white text-[34px] sm:text-[44px] leading-[0.95] tracking-[-1.5px]"
              style={SERIF}
            >
              MBE <span className="text-[#FF8533]">Alert.</span>
            </h3>
            <p
              className="mt-4 text-white/45 text-[14px] max-w-md leading-relaxed font-light"
              style={SANS}
            >
              Real time Telegram alerts for valid MBE bubble zones. Built for
              traders who can&apos;t sit at the screen all day.
            </p>
          </div>
          <div className="flex md:justify-end">
            <a
              href={link} target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#FF6E00] hover:bg-[#FF8533] text-black font-medium text-[14.5px] px-5 py-3 rounded-full transition-colors shadow-[0_12px_30px_-12px_rgba(255,110,0,0.7)]"
              style={SANS}
            >
              Get MBE Alert Now <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div
          className="mt-12 pt-6 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3"
          style={SANS}
        >
          <p className="text-white/35 text-[12.5px] font-light">
            © {new Date().getFullYear()} MBE Alert. All rights reserved.
          </p>
          <p className="text-white/35 text-[12px] max-w-2xl md:text-right font-light">
            Trading involves risk. MBE Alert is a timing layer, not a profit
            guarantee. Past performance does not guarantee future results.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
